import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Slider } from '@material-ui/core';
import { useFormContext } from '../FormContext';
const StyledSlider = styled(Slider) `
  &.value-label-display {
    padding-top: 64px;
  }
`;
const FormSlider = ({ element, edit, disabled }) => {
    const { formValues, setFormValue } = useFormContext();
    const key = element.dataSource || element.key;
    const { defaultValue, min, max, step, marks, orientation, valueLabelDisplay = 'on' } = element.config || {};
    const [value, setValue] = useState(formValues[key] || defaultValue || 0);
    useEffect(() => {
        if (typeof formValues[key] === 'number') {
            setValue(formValues[key]);
        }
        else if (typeof defaultValue === 'number') {
            setValue(defaultValue);
            // Note: Don't set default value as not to cause server side call on load
            // setFormValue(key, defaultValue as any);
        }
    }, [formValues, key, defaultValue]);
    return (React.createElement(StyledSlider, { min: min, max: max, step: typeof step === 'number' && step === 0 ? 1 : step, marks: marks, orientation: orientation, className: valueLabelDisplay === 'on' ? 'value-label-display' : '', valueLabelDisplay: valueLabelDisplay, disabled: edit || disabled, value: value, onChange: (event, value) => {
            setValue(value);
        }, onChangeCommitted: (event, value) => {
            setFormValue(key, value);
        } }));
};
export default FormSlider;
//# sourceMappingURL=FormSlider.js.map